$(document).ready(function () {
  if ($(window).width() <= 767) {
    $(".footer-block-head-custom").click(function () {
      // Get the corresponding content element
      var contentElement = $(this)
        .closest(".footer-block")
        .find(".footer-block-content-custom");

      // Toggle the visibility of the content element
      contentElement.slideToggle();

      // Toggle the "active" class on the head element
      $(this).toggleClass("active");
    });
  }

  $(".mobile-block-menu").on("click touchstart", function (event) {
    event.preventDefault();
    $("#responsive-menu-popup").modal("show");

    setTimeout(() => {
        $("#responsive-menu-popup").css("display", "block").css("opacity", "1");
    }, 50);
});

  // Add event listener for the close button
  $(".modal").on("click", ".close", function () {
    $("#responsive-menu-popup").modal("hide"); // Close the modal
    $(".top-bar-header").css("z-index", ""); // Reset z-index of top-bar-header
  });

  $(".top-menu-mobile .menu-item").each(function () {
    var $submenu = $(this).find(".submenu");
    if ($submenu.length > 0) {
      $(this).addClass("has-submenu"); // Add class 'has-submenu' by default
    }
  });

  $(".top-menu-mobile .menu-item").click(function () {
    var $submenu = $(this).find(".submenu");
    if ($submenu.length > 0) {
      $(this).toggleClass("submenu-active"); // Toggle class 'submenu-active' on menu item
      $submenu.toggleClass("submenu-child-mobile");
    }
  });

  // hero banner
  $(".hero-banner.owl-slider").owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    nav: true,
    dots: false,
  });
  $(".hero-banner.owl-slider").addClass('owl-carousel owl-theme');

  // slider section
  $(".slider-block.owl-carousel").each(function () {
    $(this).owlCarousel({
      items: 4,
      loop: false,
      margin: 30,
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 1,
        },
        1024: {
          items: 3,
        },
        1440: {
          items: 4,
        },
      },
    });
  });

  // Handle click on color label
  $(
    ".product.grid variant-selects fieldset.color .custom-color-sec label"
  ).click(function () {
    setTimeout(function () {
      var val = $(
        '.product.grid variant-selects fieldset.color .custom-color-sec input[name="Color"]:checked'
      ).val();
      $(
        ".product.grid variant-selects fieldset.color legend.form__label span.option-value"
      ).html(val);
    }, 200);
  });

  // Change text on label click
  $(".product.grid variant-selects fieldset label").click(function () {
    setTimeout(function () {
      var val = $(".product-form__buttons .product-form__submit span").html();
      if (val == "Add to cart") {
        $(".product-form__buttons .product-form__submit span").html(
          "Add to Bag"
        );
      }
    }, 800);
  });

  // Remove active class on mouseleave
  $(
    ".product-slider-section .product-item .product-details .product-detail"
  ).on("mouseleave", function () {
    $(this).parent().removeClass("active");
  });

  // Handle click on product item for mobile
  $(document).ready(function () {
    $(document).on(
      "click",
      ".product-slider-section .product-item",
      function (event) {
        if (!$(event.target).closest(".product-detail").length) {
          if ($(this).find(".product-details").hasClass("active")) {
            $(this).find(".product-details.active").removeClass("active");
          }
        }
      }
    );
  });

  // Show product details on explore variants hover
  $(".product-item .product-btn span.explore-variants").mouseenter(function () {
    var prddetail = $(this).parent().parent().find(".product-details");
    setTimeout(function () {
      prddetail.addClass("active");
      if (
        prddetail.find(
          ".product-detail .product-options fieldset[name=color] input:checked"
        ).length == 0
      ) {
        prddetail
          .find(
            ".product-detail .product-options fieldset[name=color] label:nth-child(3)"
          )
          .click();
      }
    }, 300);
  });

  // Handle click on product variant label
  // document
  //   .querySelectorAll(
  //     ".product-item .product-details .product-detail .product-options fieldset label"
  //   )
  //   .forEach(function (label) {
  //     label.addEventListener("click", function () {
  //       var variantsdata = JSON.parse(
  //         this.parentElement.parentElement.parentElement.parentElement.querySelector("script").innerHTML
  //       );
  //       var wishlist = $(this).closest('.product-details').siblings('.wishlist').find('.wishlist-engine');
  //       setTimeout(
  //         function () {
  //           var options = {};
  //           var context = this;
  //           var fieldsets = context.parentElement.parentElement.parentElement.parentElement.querySelectorAll("fieldset");
  //           console.log(fieldsets);
  //           for (var index = 0; index < 3; index++) {
  //             var fieldset = fieldsets[index];
  //             var optionElement = fieldset
  //               ? fieldset.querySelector('input[type="radio"]:checked')
  //               : null;
  //             var option = optionElement ? optionElement.value : null;
  //             var i = index + 1;
  //             options["option" + i] = {
  //               value: option,
  //             };
  //           }
  //           if (!options.option2) {
  //             options.option2.value = null;
  //           }
  //           if (!options.option3) {
  //             options.option3.value = null;
  //           }
  //           var absolute = variantsdata.filter(function (item) {
  //             return (
  //               item.option1 == options.option1.value &&
  //               item.option2 == options.option2.value &&
  //               item.option3 == options.option3.value
  //             );
  //           });
  //           var variantid = absolute.length > 0 ? absolute[0].id : false;
  //           var variantavailable = absolute.length > 0 ? absolute[0].available : false;
  //           var variantprice = absolute.length > 0 ? absolute[0].price : false;
  //           var variantcompareprice = absolute.length > 0 ? absolute[0].compare_at_price : false;
  //           var nprice = variantprice !== false ? (variantprice / 100).toFixed(2) : '0.00';
  //           var ncomapreatprice = variantcompareprice !== false ? (variantcompareprice / 100).toFixed(2) : '0.00';
  //           var price = parseFloat(nprice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  //           var comapreatprice = parseFloat(ncomapreatprice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });


            
  //           if (variantid) {
  //             context.parentElement.parentElement.parentElement.parentElement.querySelector('form.form input[name="id"]').value = variantid;
  //             wishlist.attr('data-variant_id', variantid);
  //             let variantsData = wishlist.attr('data-variants-ids');
  //             if (variantsData === '') {
  //               wishlist.attr('data-added', 'false');
  //               wishlist.find('.wishlist-icon svg path').attr('fill', 'none');
  //             } else {
  //               let variants = JSON.parse(variantsData);
              
  //               if (!variants.includes(Number(variantid))) {
  //                 wishlist.attr('data-added', 'false');
  //                 wishlist.find('.wishlist-icon svg path').attr('fill', 'none');
  //               } else {
  //                 wishlist.find('.wishlist-icon svg path').attr('fill', '#e4002b');
  //               }
  //             }

  //             var $currentElement = $(this);
  //             var $testDiv = null;
  //             while ($currentElement.length) {
  //                 if ($currentElement.hasClass('product-detail')) {
  //                     $testDiv = $currentElement;
  //                     break;
  //                 }
  //                 $currentElement = $currentElement.parent();
  //             }

  //             var pricesection = $testDiv.find('.product-desc .product-price .price');
  //             if(comapreatprice != null && comapreatprice > price){
  //               pricesection.addClass('price--on-sale');
  //               pricesection.find('.price__container .price__sale span s.price-item.price-item--regular').html('R ' + comapreatprice + ' ZAR');
  //               pricesection.find('.price__container .price__sale span.price-item.price-item--sale.price-item--last').html('R ' + price + ' ZAR');
  //               fieldsets.parent().parent().parent().find('.product-price .price').addClass('price--on-sale');
  //               fieldsets.parent().parent().parent().find('.product-price .price').find('.price__container .price__sale span s.price-item.price-item--regular').html('R ' + comapreatprice + ' ZAR');
  //               fieldsets.parent().parent().parent().find('.product-price .price').find('.price__container .price__sale span.price-item.price-item--sale.price-item--last').html('R ' + price + ' ZAR');
  //             } else {
  //               pricesection.removeClass('price--on-sale');
  //               pricesection.find('.price__container .price__sale span s.price-item.price-item--regular').html(' ');
  //               pricesection.find('.price__container .price__regular span.price-item.price-item--regular').html('R ' + price + ' ZAR');
  //               fieldsets.parent().parent().parent().find('.product-price .price').find('.price__container .price__sale span s.price-item.price-item--regular').html(' ');
  //               fieldsets.parent().parent().parent().find('.product-price .price').find('.price__container .price__regular span.price-item.price-item--regular').html('R ' + price + ' ZAR');
  //             }
  //           }
  //         }.bind(this),
  //         400
  //       );
  //     });
  //   });

  // Handle form submission
  // $(
  //   '.product-item .product-detail .product-options form[data-type="add-to-cart-form"]'
  // ).submit(function (e) {
  //   e.preventDefault();
  //   var productId = $(this).find('input[name="id"]').val();
  //   addToCart(productId);
  // });

  // // Function to add to cart
  // function addToCart(productId) {
  //   var data = {
  //     items: [
  //       {
  //         quantity: 1,
  //         id: productId,
  //       },
  //     ],
  //   };

  //   $.ajax({
  //     type: "POST",
  //     url: "/cart/add.js", // Shopify AJAX endpoint
  //     data: data,
  //     dataType: "json",
  //     success: function (response) {
  //       document.dispatchEvent(new CustomEvent("cart:refresh:opend"));
  //       console.log("Product added to cart!" + response);
  //       location.href = "/cart";
  //     },
  //     error: function (xhr, status, error) {
  //       console.error(error);
  //     },
  //   });
  // }
});

// hide show filter
$(document).ready(function () {
  // Initially show the filter
  if(window.innerWidth > 749){
    $(".product-collection-custom .js-filter").hide();
    // console.log('4');
  }
  $(".product-collection-custom .facets-vertical aside").addClass("hide-aside");
  $(".marketing-banner").addClass("sidebar-active");
  $(".product-collection-custom .product-grid-container").addClass("expand-container");
  $(".product-collection-custom .active-facets.active-facets-desktop #verticalTitle").text("Show Filters");

  // Event delegation for dynamically added elements
  $(document).on('click', '.product-collection-custom .active-facets.active-facets-desktop .facets__heading', function () {
    // Toggle the filter
    $(".product-collection-custom .js-filter").toggle();
    // Check if the filter is visible
    if(window.innerWidth < 1025){
      // console.log('1');
      if(window.innerWidth > 749){
        // console.log('2');
        setTimeout(function(){
          if ($(".product-collection-custom .js-filter").is(":visible")) {
          // If visible, remove the hide styles
            $(".product-collection-custom .facets-vertical aside").removeClass("hide-aside");
            $(".marketing-banner").removeClass("sidebar-active");
            $(".product-collection-custom .product-grid-container").removeClass("expand-container");
            $(".product-collection-custom .active-facets.active-facets-desktop #verticalTitle").text("Hide Filters");
          } else {
          // If hidden, add the hide styles
            $(".product-collection-custom .facets-vertical aside").addClass("hide-aside");
            $(".marketing-banner").addClass("sidebar-active");
            $(".product-collection-custom .product-grid-container").addClass("expand-container");
            $(".product-collection-custom .active-facets.active-facets-desktop #verticalTitle").text("Show Filters");
          }
        }, 700);
      }
    } else {
      // console.log('3');
      if ($(".product-collection-custom .js-filter").is(":visible")) {
      // If visible, remove the hide styles
        $(".product-collection-custom .facets-vertical aside").removeClass("hide-aside");
        $(".marketing-banner").removeClass("sidebar-active");
        $(".product-collection-custom .product-grid-container").removeClass("expand-container");
        $(".product-collection-custom .active-facets.active-facets-desktop #verticalTitle").text("Hide Filters");
      } else {
      // If hidden, add the hide styles
        $(".product-collection-custom .facets-vertical aside").addClass("hide-aside");
        $(".marketing-banner").addClass("sidebar-active");
        $(".product-collection-custom .product-grid-container").addClass("expand-container");
        $(".product-collection-custom .active-facets.active-facets-desktop #verticalTitle").text("Show Filters");
      }
    }
  });

  // $(".product-collection-custom .active-facets.active-facets-desktop #verticalTitle").text("Hide Filters");
});

$(document).on('click', '.product-item .product-details .product-detail .product-options fieldset label, .product-card-wrapper .product-details .product-detail .product-options fieldset label', function() {
    var variantsdata = JSON.parse($(this).closest('.product-detail').find('script').html());
    // console.log(variantsdata);
    var wishlist = $(this).closest('.product-details').siblings('.wishlist').find('.wishlist-engine');

    setTimeout(function() {
      var options = {};
      var fieldsets = $(this).closest('.product-detail').find('fieldset');
      for (var index = 0; index < 3; index++) {
        var optionElement = fieldsets.eq(index).find('input[type="radio"]:checked');
        var option = optionElement.length > 0 ? optionElement.val() : null;
        options['option' + (index + 1)] = {
          value: option
        };
      }
      if (!options.option2) {
        options.option2 = { value: null };
      }
      if (!options.option3) {
        options.option3 = { value: null };
      }
      // console.log(options);
      var absolute = variantsdata.filter(function(item) {
        return item.option1 == options.option1.value && item.option2 == options.option2.value && item.option3 == options.option3.value;
      });
      var variantid = absolute.length > 0 ? absolute[0].id : false;
      var variantimage = absolute.length > 0 && absolute[0].featured_image ? absolute[0].featured_image.src : null;
      // console.log(variantimage);
      var variantavailable = absolute.length > 0 ? absolute[0].available : false;
      var variantprice = absolute.length > 0 ? absolute[0].price : false;
      var variantcompareprice = absolute.length > 0 ? absolute[0].compare_at_price : false;
      var nprice = variantprice !== false ? (variantprice / 100).toFixed(2) : '0.00';
      var ncomapreatprice = variantcompareprice !== false ? (variantcompareprice / 100).toFixed(2) : '0.00';
      var price = parseFloat(nprice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var comapreatprice = parseFloat(ncomapreatprice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      if (variantid) {

        if(variantimage){
           var productDetails = $(this).closest('.product-details');
          var images = productDetails.siblings('.product-img-carousel').find('.owl-stage .owl-item .product-img img');
        
          // images.each(function() {
          //   if ($(this).attr('src') == variantimage) {
          //     var active_slide = $(this).closest('.owl-item');
          //     var index = active_slide.index();
              
          //     var carousel = productDetails.siblings('.product-img-carousel.owl-carousel');
          //     console.log(carousel);
          //     carousel.trigger('to.owl.carousel', [index, 300]);
          //   }
          // });
        }

        
        $(this).parent().parent().parent().parent().find('form.form').find('input[name="id"]').val(variantid);
        var addToCartButton = $(this).parent().parent().parent().parent().find('form.form').find('button[name="Add To Cart"]');
        if (!variantavailable) {
          addToCartButton.html('Sold Out').prop('disabled', true);
        } else {
          addToCartButton.html('Add To Cart').prop('disabled', false);
        }
        wishlist.attr('data-variant_id', variantid);
        let variantsData = wishlist.attr('data-variants-ids');
        if (variantsData === '') {
          wishlist.attr('data-added', 'false');
          wishlist.find('.wishlist-icon svg path').attr('fill', 'none');
        } else {
          let variants = JSON.parse(variantsData);
        
          if (!variants.includes(Number(variantid))) {
            wishlist.attr('data-added', 'false');
            wishlist.find('.wishlist-icon svg path').attr('fill', 'none');
          } else {
            wishlist.find('.wishlist-icon svg path').attr('fill', '#e4002b');
          }
        }

        var pricesection = fieldsets.parent().parent().find('.product-desc .product-price .price');
        if(comapreatprice != null && comapreatprice > price){
          pricesection.addClass('price--on-sale');
          pricesection.find('.price__container .price__sale span s.price-item.price-item--regular').html('R ' + comapreatprice + ' ZAR');
          pricesection.find('.price__container .price__sale span.price-item.price-item--sale.price-item--last').html('R ' + price + ' ZAR');
          fieldsets.parent().parent().find('.product-price .price').addClass('price--on-sale');
          fieldsets.parent().parent().find('.product-price .price').find('.price__container .price__sale span s.price-item.price-item--regular').html('R ' + comapreatprice + ' ZAR');
          fieldsets.parent().parent().find('.product-price .price').find('.price__container .price__sale span.price-item.price-item--sale.price-item--last').html('R ' + price + ' ZAR');
        } else {
          pricesection.removeClass('price--on-sale');
          pricesection.find('.price__container .price__sale span s.price-item.price-item--regular').html(' ');
          pricesection.find('.price__container .price__regular span.price-item.price-item--regular').html('R ' + price + ' ZAR');
          fieldsets.parent().parent().find('.product-price .price').find('.price__container .price__sale span s.price-item.price-item--regular').html(' ');
          fieldsets.parent().parent().find('.product-price .price').find('.price__container .price__regular span.price-item.price-item--regular').html('R ' + price + ' ZAR');
        }
      }
    }.bind(this), 400);
  });
$(window).load(function() {
  // Initialize OwlCarousel for custom media product block if items are more than 5
  if ($('.custom-media-product-block .custom-media-varient-list .item').length > 5) {
    $(".custom-media-product-block .custom-media-varient-list").owlCarousel({
      loop: false,
      margin: 10,
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 4
        },
        500: {
          items: 5
        }
      }
    });
  }

  // Initialize OwlCarousel for product info variant selects if items are more than 5
  $('product-info variant-selects .product-form__input--pill .custom-option-group').each(function(){
    if ($(this).find('.custom-box-option').length > 5) {
      $(this).owlCarousel({
        loop: false,
        margin: 6,
        nav: true,
        dots: false,
        responsive: {
          0: {
            items: 4
          },
          500: {
            items: 5
          }
        }
      });
    }
  });
});  

// size chart text change
$(document).ready(function(){
    $('#sizeguideModal .modal-content .static-page .help-topics-size-charts h1').text('Size Chart');
});


$(document).ready(function() {
  function applyHoverEffect() {
    $('td').hover(function() {
      $('td').removeClass('active active-row active-col');
      $(this).addClass('active');
      $(this).closest('tr').find('td').not(this).addClass('active-row');
      var colIndex = $(this).index();
      $('table tr').each(function() {
        $(this).find('td').eq(colIndex).not('.active').addClass('active-col');
      });
    }, function() {
      $('td').removeClass('active active-row active-col');
    });
  }

  var intervalId = setInterval(function() {
    if ($('.size-guide-table').length > 0) {
      applyHoverEffect();
      clearInterval(intervalId);
    }
  }, 500);
});


$(document).ready(function(){
    $('.product__info-wrapper variant-selects fieldset.denomination .form__label').text('Value');
});

$('.wp-block-embed-youtube .wp-block-embed__wrapper').each(function(){
    var url = $(this).html();
    console.log(url);
    url = url.replace('watch?v=', 'embed/').replace('&amp;feature=youtu.be', '');
    $(this).html('<iframe src="' + url + '" height="400" width="100%"></iframe>');
});

// size chart open popup
 function openModal() {
    document.getElementById("sizeguideModal").style.display = "block";
  }

  function closeModal() {
    document.getElementById("sizeguideModal").style.display = "none";
  }

  window.onclick = function(event) {
    var modal = document.getElementById("sizeguideModal");
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }